import moment from "moment";
import React from "react";
import parse from 'html-react-parser';
import { NOTES_CONSTANT } from "../../common/constant/page-constants";
import "./Notes.scss";
import { StatefulEditor } from "../StatefulEditor/StatefulEditor";

export function Notes(props) {

    const type = props.type || NOTES_CONSTANT.MEDIUM;
    return (
        <div
            className={props.active ? `notes ${type} active` : `notes ${type}`}
            onClick={() => { if (props.handleClick) props.handleClick(props.data) }}>
            <div className="notes-header">
                <div>
                    <span className="notes-date">{moment(props.data.createdAt).format("DD MMMM YYYY")}</span>
                    {/* <span className="pipe">|</span> */}
                    <span className="notes-time">{moment(props.data.createdAt).format("HH:mm a")}</span>
                    <span className={`notes-user ${type}`}>
                        {`${props.notesType}: ${props.data.createdByUserName} (${props.data.createdByUserId})`}
                    </span>
                    {/* {type === NOTES_CONSTANT.SMALL && <span className="notes-user">
                        {`${props.notesType}: ${props.data.createdByUserName} (${props.data.createdByUserId})`}
                    </span>} */}
                </div>
                {type === NOTES_CONSTANT.LARGE && props.editActiveNote && props.showEdit && <div className="edit-note-container">
                    <div className="cancel-btn btn-common" onClick={props.handleEditNoteCancel}>
                        Cancel
                    </div>
                    <div className="edit-btn btn-common" onClick={props.handleEditNoteSave}>
                        Save
                    </div>
                </div>}
                {type === NOTES_CONSTANT.LARGE && !props.editActiveNote && props.showEdit && <div className="edit-note-container">
                    <div className="edit-btn btn-common" onClick={props.handleEditActiveNote}>
                        Edit
                    </div>
                </div>}
                {/* <div className="notes-date-time">
                    {`${props.data.date}   |   ${props.data.time}`}
                </div> */}
            </div>
            {!props.editActiveNote && <div className="notes-content">
                {parse(props.data.message)}
            </div>}
            {props.editActiveNote && <div className="editor-container">
                <StatefulEditor onChange={(data) => props.handleNoteChange(data)} value={props.data.message || ""} />
            </div>}
        </div>
    );
}